exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "ul.error-messages li{color:#c00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./medscape_modules/qna/error-messages/styles.scss
// module id = 636
// module chunks = 0